import { render } from "./TicketCard.vue?vue&type=template&id=51527faf&scoped=true"
import script from "./TicketCard.vue?vue&type=script&lang=js"
export * from "./TicketCard.vue?vue&type=script&lang=js"

import "./TicketCard.vue?vue&type=style&index=0&id=51527faf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51527faf"]])

export default __exports__